import React, { } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

const AddBot = (props) => {
  const { handleSubmit, register, formState: { errors }, reset } = useForm()
  const addBot = (data) => {
    props.createBot(data.botName);
     props.onHide();
     reset();
  };

  const handleClose = () => {
    reset();
    props.onHide();
  };

  const { t } = useTranslation();

  return (
    <>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered 
          onHide={handleClose}>
        <form onSubmit={handleSubmit(addBot)}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">{t("Add New Bot")} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label className="form-label">{t("Name")}</label>
              <input
                className={`form-control ${errors.botName ? 'is-invalid' : ''}`}
                type="text"
                name="botName"
                id="botName"
                placeholder="Enter bot name"
                {...register('botName', { required: "Bot name is required" })}
              />
              {errors.botName && <div className="invalid-feedback">{errors.botName.message}</div>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <input type="submit" className="button" value={t("Submit")} />
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AddBot;
